import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/holidays_2023/holiday_theme_banner.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/holidays_2023/holiday_theme.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/components/api/GameAPIContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/components/blog/SubscribeToRoyalListPrompt.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/components/env/EnvContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/components/layout/ShareButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
